
export default function ContactInfo() {
  const contactDetails = [
    {
      icon: 'ri-phone-line',
      title: 'Téléphone',
      info: '71 348 109',
      description: 'Du lundi au samedi'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email',
      info: 'cobra@cobrasecurite.com.tn',
      description: 'Réponse sous 24h'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Adresse',
      info: '5, rue Ali Darghouth',
      description: 'Imm. Mostakbel 2 ap. B73 - Tunis'
    },
    {
      icon: 'ri-time-line',
      title: 'Horaires',
      info: 'Du lundi au samedi',
      description: '8h00 - 18h00'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nos <span className="text-red-600">Coordonnées</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Notre équipe est à votre disposition pour répondre à toutes vos questions 
            et vous accompagner dans vos projets de sécurité.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="flex items-center space-x-6">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-phone-line text-2xl text-red-600"></i>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Téléphone</h3>
                <div className="text-lg font-semibold text-red-600 mb-1">71 348 109</div>
                <p className="text-gray-600">Du lundi au samedi</p>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="flex items-start space-x-6">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-2xl text-red-600"></i>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Email</h3>
                <div className="text-base font-semibold text-red-600 mb-1 break-all">cobra@cobrasecurite.com.tn</div>
                <p className="text-gray-600">Réponse sous 24h</p>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="flex items-center space-x-6">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-line text-2xl text-red-600"></i>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Adresse</h3>
                <div className="text-lg font-semibold text-red-600 mb-1">5, rue Ali Darghouth</div>
                <p className="text-gray-600">Imm. Mostakbel 2 ap. B73 - Tunis</p>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="flex items-center space-x-6">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-time-line text-2xl text-red-600"></i>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Horaires</h3>
                <div className="text-lg font-semibold text-red-600 mb-1">Du lundi au samedi</div>
                <p className="text-gray-600">8h00 - 18h00</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 bg-white rounded-2xl shadow-lg p-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Intervention <span className="text-red-600">Rapide</span>
              </h3>
              <div className="space-y-4">
                <div className="flex items-center">
                  <i className="ri-shield-check-line text-red-600 text-xl mr-4"></i>
                  <span className="text-gray-700">Service d'urgence 24h/7j</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-time-line text-red-600 text-xl mr-4"></i>
                  <span className="text-gray-700">Intervention sous 2h en région de Tunis</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-tools-line text-red-600 text-xl mr-4"></i>
                  <span className="text-gray-700">Équipe technique certifiée</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-customer-service-line text-red-600 text-xl mr-4"></i>
                  <span className="text-gray-700">Support technique gratuit</span>
                </div>
              </div>
            </div>
            <div className="text-center">
              <img
                src="https://public.readdy.ai/ai/img_res/3196c0e61838e7a1b257ec704a01636b.jpg"
                alt="Technicien Cobra Sécurité"
                className="w-full h-80 object-cover object-top rounded-xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
